module.exports = __webpack_public_path__ + "static/pool3-601d5c6147b4485a14c1ae7a722f21c0.jpg";